if (!isMobileX(1199) && $(".anuncio-lateral").length > 0) {
  const topSpacing = $(".header-full").outerHeight() + 20;
  const bottomSpacing = $(".footer-imoveis").outerHeight() + 576;
  $(".anuncio-lateral").sticky({
    topSpacing: topSpacing,
    bottomSpacing: bottomSpacing,
  });
}